interface FirebaseTokenUser {
  getIdToken(forceRefresh?: boolean): Promise<string>;
}

export interface CachedFirebaseAccessToken {
  readonly token: string;
  readonly expiresAtMs: number;
}

const ACCESS_TOKEN_EXPIRY_MARGIN_MS = 60_000;

export function usableCachedAccessToken(
  cached: CachedFirebaseAccessToken | null,
  nowMs = Date.now(),
): string | null {
  if (
    !cached ||
    !cached.token ||
    !Number.isFinite(cached.expiresAtMs) ||
    cached.expiresAtMs - nowMs <= ACCESS_TOKEN_EXPIRY_MARGIN_MS
  ) {
    return null;
  }
  return cached.token;
}

export function authenticatedTokenUser<T>(
  currentUser: T | null,
  verifiedSessionUser: T | null,
): T | null {
  return verifiedSessionUser ?? currentUser;
}

export function validAccessToken(
  user: FirebaseTokenUser,
  forceRefresh = false,
): Promise<string> {
  return user.getIdToken(forceRefresh);
}
